var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('div',{staticClass:"app-content"},[_c('Navbar'),_c('SearchTable')],1),_c('footer',[_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }